import React from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import HeadingTwo from '../../Fashion/Heading'
import PrevArrow from '../../Fashion/PrevArrow';
import NextArrow from '../../Fashion/NextArrow';
import { useDispatch, useSelector } from 'react-redux';
import { getImageUrlPath, SHOP_URL } from '../../../app/constants';
import { Link } from 'react-router-dom';

const Sports = (props) => {
  let categories = useSelector((state) => state.products.categories);
  let settings = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 900,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      }
    }
    ]
  };

  const dispatch = useDispatch()
  return (

<section id="instagram_area_one" style={{ marginBottom: "50px" }}>
  <div className="container-fluid">
    <HeadingTwo heading="Shop By Categories" para="" />
    <div className="row">
      <div className="col-lg-12">
        <div className="instagram_post_slider">
          <Slider {...settings}>
            {categories.map((data, index) => (
              <Link 
                to={SHOP_URL} 
                className="instgram_post" 
                onClick={() => {
                  dispatch({ 
                    type: "products/updateFilters", 
                    payload: { type: "category", filters: [{ id: data.id }] }
                  });
                }} 
                key={index}
                style={{
                  textDecoration: 'none', 
                  color: 'inherit', 
                  display: 'block', 
                  borderRadius: '10px', 
                  overflow: 'hidden', 
                  transition: 'transform 0.3s ease',
                  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                }}
              >
                <div 
                  style={{ 
                    padding: "10px",
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    textAlign: 'center',
                    transition: 'transform 0.3s ease',
                    overflow: 'hidden',
                    cursor: 'pointer',
                  }}
                >
                  <img 
                    src={getImageUrlPath(data.image)} 
                    style={{ 
                      height: "350px", 
                      width: '100%', 
                      objectFit: 'cover', 
                      borderRadius: '10px', 
                      transition: 'transform 0.3s ease',
                    }} 
                    alt="img" 
                  />
                  <span 
                    style={{
                      display: 'block',
                      marginTop: '10px',
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#333',
                      textTransform: 'uppercase',
                    }}
                  >
                    {data?.name}
                  </span>
                </div>
              </Link>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  </div>
</section>

  )
}

export default Sports